<template>
  <div class="label-info app-panel blank-v blank-h">
    <el-form class="max-width" ref="form" :model="form" :rules="rules" :label-width="labelWidth">
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" clearable></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="note">
        <el-input v-model="form.note" type="textarea" :rows="10"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import LabelService from '@/io/label.js';

  export default {
    name: 'LabelInfo',
    data() {
      return {
        id: this.$route.params.id,
        form: {
          name: '',
          note: ''
        },
        rules: {
          name: [
            {
              required: true, message: '请输入名称'
            }
          ]
        }
      }
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          if (newValue) {
            this.initDatas();
          }
        },
        immediate: true
      }
    },
    methods: {
      initDatas() {
        LabelService.info(this.id).then(res => {
          this.form.name = res.data.project_external_staff_tag.external_staff_tag_name;
          this.form.note = res.data.project_external_staff_tag.external_staff_tag_description;
        }).catch(() => {});
      },
      submit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            if (this.id) {
              LabelService.edit(
                this.id,
                this.form.name,
                this.form.note
              ).then(() => {
                this.$message.success('编辑成功');
                this.cancel();
              }).catch(() => {});
            } else {
              LabelService.add(
                this.form.name,
                this.form.note
              ).then(() => {
                this.$message.success('编辑成功');
                this.cancel();
              }).catch(() => {});
            }
          }
        });
      },
      cancel() {
        this.$router.push({
          path: '/label_manage'
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>